import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { UserModel } from '../../../user.model';
import {
    FiUserEditDataFieldActivation_Settings,
    TFiUserEditDataFieldActivation_Settings,
} from '@fi-app/data-field/data-field-edit/active/active.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-user-edit-status',
    templateUrl: './fi-user-edit-status.component.html',
    styleUrls: ['./fi-user-edit-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-edit-status' },
    providers: [
        {
            provide: FiUserEditDataFieldActivation_Settings,
            deps: [FiUserEditStatusComponent],
            useFactory: (userEditComponent: FiUserEditStatusComponent): TFiUserEditDataFieldActivation_Settings => ({
                datePickerLabelStartDate: userEditComponent.appTextService.get('common.start_date'),
                datePickerLabelEndDate: userEditComponent.appTextService.get('common.end_date'),
                datePickerAppearance: 'outline',
                isItemActivatedDisabled: userEditComponent.isCurrentUserId(),
            }),
        },
        { provide: FiComponentsContainer, useExisting: FiUserEditStatusComponent },
    ],
    standalone: false,
})
export class FiUserEditStatusComponent extends FiComponentsContainer {
    @Input() dataFields: DataFieldModel[] = [];
    @Input() user: UserModel;

    constructor(
        private appTextService: AppTextService,
        private userDataService: FiUserDataService,
    ) {
        super();
    }

    isCurrentUserId() {
        return this.userDataService.getUserId() === this.user.Id;
    }
}
